<div class="container">
  <div class="icon">
    <rd-shared-icon
      class="icon-not-found"
      [iconSymbol]="'icon-not-found'"
      [iconTheme]="'error'"></rd-shared-icon>
  </div>
  <div class="text-content">
    <h1 class="page-not-found-header">
      {{ 'core.page_not_found.header' | translate }}
    </h1>
    <p class="page-not-found-description">
      {{ 'core.page_not_found.description' | translate }}
    </p>
  </div>
</div>
